module.exports = __webpack_public_path__ + "img/arrow-from-to.df4eaf6d.svg";